module.exports = __webpack_public_path__ + "static/img/loginLeft.ba0d304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginLeft.png
// module id = hMJZ
// module chunks = 1